// Shared body-scroll lock with reference counting. Multiple modals/sheets
// can be open at once (e.g. a transient confirmation on top of a sheet);
// using a counter on body.dataset.modalLocks keeps the lock until *every*
// caller releases it.
//
// State lives on document.body (not module scope) so Turbo morphs that swap
// body content can re-read the count rather than zeroing it.
const KEY = "modalLocks"

function read() {
  return parseInt(document.body.dataset[KEY], 10) || 0
}

export function lock() {
  document.body.dataset[KEY] = String(read() + 1)
  document.body.style.overflow = "hidden"
}

export function unlock() {
  const remaining = Math.max(0, read() - 1)
  document.body.dataset[KEY] = String(remaining)
  if (remaining === 0) document.body.style.overflow = ""
}
